import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Roundtripcabnavimumbai() {



    const cardData = {

keyword: "Round Trip Cab Navi Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Round Trip Cab Navi Mumbai services for business travel, family vacations, pilgrimage tours, weekend getaways, airport transfers, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional chauffeurs. With flexible round-trip packages, transparent pricing, 24x7 availability, doorstep pickup across Navi Mumbai, and safe highway travel, we ensure a comfortable, convenient, and hassle-free journey for every traveler.",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most popular round-trip destinations from Navi Mumbai, known for business travel, educational institutions, historical attractions, and modern city life."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a favorite weekend getaway famous for waterfalls, caves, scenic valleys, and pleasant weather throughout the year."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a renowned hill station known for strawberry farms, lakes, viewpoints, and family-friendly tourism attractions."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba and remains one of the most frequently booked round-trip cab routes."
    },
    {
        title: "Nashik",
        description:
            "Nashik attracts visitors with Trimbakeshwar Jyotirlinga, vineyards, temples, and spiritual tourism experiences."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for Mahalaxmi Temple, cultural heritage, historical landmarks, and authentic Maharashtrian cuisine."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a scenic Konkan destination famous for Ganpatipule Temple, beaches, sea forts, and coastal landscapes."
    },
    {
        title: "Goa",
        description:
            "Goa is one of India’s top holiday destinations known for beaches, nightlife, water sports, churches, and coastal tourism."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is home to Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, and numerous historical attractions."
    },
    {
        title: "Saputara",
        description:
            "Saputara is a picturesque hill station near Maharashtra and Gujarat, known for ropeway rides, viewpoints, lakes, and natural beauty."
    }
],



services: [
{
name: "Round Trip Cab Navi Mumbai",
description: "Round Trip Cab Navi Mumbai service by 1Touch Cabs provides reliable and comfortable transportation for local, outstation, business, family, and leisure travel. We offer Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles driven by professional chauffeurs. Whether you require same-day return travel, weekend trips, business meetings, religious tours, airport transfers, or family vacations, our round trip cab service ensures safe travel, timely pickups, comfortable seating, and flexible scheduling. With transparent pricing, 24x7 customer support, clean vehicles, and experienced drivers, we make round trip travel from Navi Mumbai convenient, affordable, and hassle-free."
},
{
name: "Navi Mumbai Round Trip Taxi",
description: "Navi Mumbai Round Trip Taxi service offers dependable transportation for passengers looking for convenient return travel solutions. 1Touch Cabs provides clean air-conditioned vehicles, experienced chauffeurs, and flexible travel plans suitable for families, tourists, corporate travelers, and groups. We ensure comfortable journeys, safe highway travel, and punctual service throughout the trip."
},
{
name: "Round Trip Taxi Service in Navi Mumbai",
description: "Round Trip Taxi Service in Navi Mumbai provides complete return transportation for local and outstation journeys. 1Touch Cabs offers well-maintained vehicles, professional drivers, and personalized travel arrangements. Our service focuses on passenger comfort, timely pickups, reliable support, and stress-free travel experiences."
},
{
name: "Round Trip Cab Service Navi Mumbai",
description: "Round Trip Cab Service Navi Mumbai delivers convenient and affordable transportation for one-day tours, business travel, family outings, and long-distance trips. 1Touch Cabs provides a modern fleet of vehicles, courteous chauffeurs, and dependable customer support. We ensure smooth travel and comfortable return journeys."
},
{
name: "Book Round Trip Cab Navi Mumbai",
description: "Book Round Trip Cab Navi Mumbai service allows passengers to reserve return travel quickly and easily. 1Touch Cabs offers instant booking assistance, multiple vehicle choices, transparent pricing, and reliable chauffeur services. We simplify travel planning while ensuring a comfortable and safe journey."
},
{
name: "Private Round Trip Taxi Navi Mumbai",
description: "Private Round Trip Taxi Navi Mumbai service offers exclusive transportation for individuals, families, and corporate travelers seeking privacy and flexibility. 1Touch Cabs provides dedicated vehicles, experienced drivers, and customized travel schedules. Our service ensures convenience, comfort, and personalized travel support."
},
{
name: "Best Round Trip Cab Service in Navi Mumbai",
description: "Best Round Trip Cab Service in Navi Mumbai provides premium transportation with a focus on comfort, reliability, and customer satisfaction. 1Touch Cabs offers clean vehicles, professional chauffeurs, and flexible travel packages. We ensure smooth journeys, timely service, and excellent travel experiences."
},
{
name: "Affordable Round Trip Cab Navi Mumbai",
description: "Affordable Round Trip Cab Navi Mumbai service offers budget-friendly transportation without compromising safety or comfort. 1Touch Cabs provides economical travel packages, experienced drivers, and well-maintained vehicles. We help passengers enjoy reliable round trip travel at competitive rates."
},
{
name: "Reliable Round Trip Taxi Navi Mumbai",
description: "Reliable Round Trip Taxi Navi Mumbai service ensures dependable transportation for local and outstation travel requirements. 1Touch Cabs offers punctual pickups, courteous chauffeurs, and comfortable vehicles. Our focus is on passenger safety, travel convenience, and consistent service quality."
},
{
name: "Round Trip Cab Navi Mumbai Fare",
description: "Round Trip Cab Navi Mumbai Fare service provides transparent and competitive pricing for return travel requirements. 1Touch Cabs offers affordable fare options for Sedan, SUV, Innova, Innova Crysta, Ertiga, and Tempo Traveller vehicles. We maintain fair pricing with no hidden charges."
},
{
name: "Navi Mumbai Round Trip Taxi Charges",
description: "Navi Mumbai Round Trip Taxi Charges service offers clear and affordable pricing for customers planning return journeys. 1Touch Cabs provides flexible fare packages, multiple vehicle categories, and dependable service. Our pricing structure is transparent and designed to deliver excellent value."
},
{
name: "Cheapest Round Trip Cab in Navi Mumbai",
description: "Cheapest Round Trip Cab in Navi Mumbai service provides economical transportation solutions for families, individuals, and business travelers. 1Touch Cabs offers affordable fares, clean vehicles, and experienced chauffeurs. We ensure cost-effective travel while maintaining comfort and reliability."
},
{
name: "Round Trip Cab Booking Navi Mumbai",
description: "Round Trip Cab Booking Navi Mumbai service allows customers to schedule return travel conveniently with instant confirmation and professional support. 1Touch Cabs offers flexible booking options, transparent pricing, and a wide range of vehicles. We ensure a smooth and hassle-free reservation process."
},
{
name: "Navi Mumbai Round Trip Cab Price",
description: "Navi Mumbai Round Trip Cab Price service provides affordable pricing options for local and outstation return journeys. 1Touch Cabs offers vehicle choices ranging from Sedan to Tempo Traveller, ensuring suitable solutions for every budget and travel requirement."
},
{
name: "One Day Round Trip Cab Navi Mumbai",
description: "One Day Round Trip Cab Navi Mumbai service is ideal for business meetings, sightseeing tours, pilgrimages, and short-distance travel. 1Touch Cabs provides reliable vehicles, professional chauffeurs, and efficient travel planning. We ensure comfortable same-day return transportation."
},
{
name: "Same Day Return Cab Navi Mumbai",
description: "Same Day Return Cab Navi Mumbai service offers convenient transportation for travelers requiring departure and return on the same day. 1Touch Cabs ensures punctual pickups, flexible schedules, and comfortable travel arrangements. Our service is perfect for corporate, personal, and leisure trips."
},
{
name: "Family Round Trip Cab Navi Mumbai",
description: "Family Round Trip Cab Navi Mumbai service provides spacious and comfortable vehicles for family vacations, pilgrimages, weddings, and weekend outings. 1Touch Cabs offers safe transportation, experienced chauffeurs, and family-friendly travel solutions for a pleasant journey."
},
{
name: "Corporate Round Trip Taxi Navi Mumbai",
description: "Corporate Round Trip Taxi Navi Mumbai service is designed for business travelers requiring professional and reliable transportation. 1Touch Cabs offers executive vehicles, punctual service, experienced chauffeurs, and flexible travel arrangements. We help businesses manage travel efficiently and comfortably."
},
{
name: "Doorstep Pickup Round Trip Cab Navi Mumbai",
description: "Doorstep Pickup Round Trip Cab Navi Mumbai service provides maximum convenience with pickup and drop directly from homes, offices, hotels, or any preferred location. 1Touch Cabs offers comfortable vehicles, professional drivers, and dependable service. We ensure a seamless travel experience from start to finish."
}
],

tableData: [
["Round Trip Cab Navi Mumbai","Navi Mumbai Round Trip Taxi"],
["Round Trip Taxi Service in Navi Mumbai","Round Trip Cab Service Navi Mumbai"],
["Book Round Trip Cab Navi Mumbai","Private Round Trip Taxi Navi Mumbai"],
["Best Round Trip Cab Service in Navi Mumbai","Affordable Round Trip Cab Navi Mumbai"],
["Reliable Round Trip Taxi Navi Mumbai","Round Trip Cab Navi Mumbai Fare"],
["Navi Mumbai Round Trip Taxi Charges","Cheapest Round Trip Cab in Navi Mumbai"],
["Round Trip Cab Booking Navi Mumbai","Navi Mumbai Round Trip Cab Price"],
["One Day Round Trip Cab Navi Mumbai","Same Day Return Cab Navi Mumbai"],
["Family Round Trip Cab Navi Mumbai","Corporate Round Trip Taxi Navi Mumbai"],
["Doorstep Pickup Round Trip Cab Navi Mumbai","Book Round Trip Cab Navi Mumbai"]
],














whychoose: [
    {
        WhyChooseheading: "Reliable Round Trip Cab Service in Navi Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Round Trip Cab Services in Navi Mumbai for business travel, family vacations, airport transfers, pilgrimages, sightseeing tours, and outstation journeys."
    },
    {
        WhyChooseheading: "Convenient Same Vehicle for Complete Journey",
        WhyChoosedescription: "Enjoy the convenience of traveling with the same cab and driver throughout your trip, ensuring comfort, familiarity, and hassle-free transportation."
    },
    {
        WhyChooseheading: "Perfect for Family and Corporate Travel",
        WhyChoosedescription: "Whether you are planning a family holiday, business meeting, wedding function, temple visit, or corporate event, our round-trip cab services offer maximum flexibility."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "Popular Outstation Destinations Covered",
        WhyChoosedescription: "Book round-trip cabs from Navi Mumbai to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Kolhapur, Ahmedabad, Ujjain, and many other destinations."
    },
    {
        WhyChooseheading: "Pickup Available Across Navi Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, route expertise, punctual service, and a comfortable travel experience throughout the entire journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Groups, and Tourists",
        WhyChoosedescription: "From small families and couples to corporate teams and large tourist groups, we provide suitable transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What is a Round Trip Cab Service in Navi Mumbai?",
        answer: "Round Trip Cab Service allows customers to book a cab for both onward and return journeys with flexible travel schedules."
    },
    {
        question: "Can I book a round-trip cab for outstation travel?",
        answer: "Yes, round-trip cab services are available for Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Lonavala, Kolhapur, and many other destinations."
    },
    {
        question: "Which vehicles are available for round-trip bookings?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Can I customize my travel itinerary?",
        answer: "Yes, customers can customize travel schedules, sightseeing stops, hotel stays, temple visits, and multiple destinations."
    },
    {
        question: "Do you provide round-trip airport transfers?",
        answer: "Yes, customers can book round-trip airport transportation from Mumbai Airport and Navi Mumbai Airport."
    },
    {
        question: "Are Tempo Travellers available for group tours?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, weddings, and pilgrimage tours."
    },
    {
        question: "Can I keep the same driver throughout the trip?",
        answer: "Yes, customers generally travel with the same vehicle and driver for the entire round-trip journey."
    },
    {
        question: "Can pickup be arranged from any Navi Mumbai location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Navi Mumbai."
    },
    {
        question: "Is advance booking recommended for round-trip travel?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning, especially during weekends and holiday seasons."
    },
    {
        question: "How can I book a Round Trip Cab in Navi Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sandeep Kulkarni",
        feedback:
            "We booked a round-trip cab from Navi Mumbai for a family vacation. The vehicle was comfortable, the driver was professional, and the entire journey was managed perfectly.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Shah",
        feedback:
            "Our round-trip pilgrimage tour was extremely smooth and convenient. The cab was clean, spacious, and the driver was very cooperative throughout the trip.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Round Trip Cab Navi Mumbai",
  "image": "https://www.mumbaiairportcabs.com/assets/images/round-trip-cab-navi-mumbai.jpg",
  "description": "Book Round Trip Cab in Navi Mumbai for comfortable and hassle-free travel. Mumbai Airport Cabs offers reliable round trip taxi service with professional drivers, clean AC vehicles, and 24x7 availability for local and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹2,499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/round-trip-cab-navi-mumbai"
  }
};




    return (
        <div>


<Helmet>
  <title>Round Trip Cab Navi Mumbai | Reliable Taxi Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Round Trip Cab in Navi Mumbai for local and outstation travel. Affordable round trip taxi service with professional drivers and 24x7 booking support."
  />

  <meta
    name="keywords"
    content="Round Trip Cab Navi Mumbai, Navi Mumbai Round Trip Taxi, Round Trip Taxi Service in Navi Mumbai, Round Trip Cab Service Navi Mumbai, Book Round Trip Cab Navi Mumbai, Private Round Trip Taxi Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Roundtripcabnavimumbai;